import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getCookie } from '../helpers/utils';


@Injectable({
  providedIn: 'root'
})
export class LocationsService {

  private _apiURLPrefix = '/api/v1/';
  private _citiesListURL = `${this._apiURLPrefix}city/`;
  private _countriesListURL = `${this._apiURLPrefix}country/`;
  private _formCitiesURL = (countryId?: number) => {
    return typeof countryId !== 'number'
      ? this._citiesListURL
      : `${this._citiesListURL}?country=${countryId}`;
  }

  constructor(
    private http: HttpClient,
  ) { }

  get(q: string, selectedCountryId?: number) {
    return this.http.get(
      this._formCitiesURL(selectedCountryId), {
      params: {
        search: q,
      }
    });
  }

  getById(id: number) {
    return this.http.get(`${this._citiesListURL}${id}`);
  }

  searchCountries(countryPrefix: string) {
    const urlWithQuery = `${this._countriesListURL}?search=${countryPrefix}`;
    return this.http.get(urlWithQuery);
  }

}
